fragment category on CategoryInterface {
    id
    title
}
